import ActiveRecord from './ActiveRecord';
import NetworkLayer from '../utils/networkLayer';

class PinnedBlogs extends ActiveRecord {
  constructor() {
    super();
  }

  getPinnedBlogs(url) {
    return NetworkLayer.getJson(url)
      .then(response => response)
      .catch(e => e);
  }

  // pageSlug travels as a query param, not a path segment: the slugs are paths
  // ("/solutions/venture-capital"), and a slash inside a path variable 404s
  // before it ever reaches the controller.
  savePinnedBlogs(url, { pageSlug, blogIds }) {
    const request = { data: { blogIds } };
    return NetworkLayer.putJson(`${url}/page?pageSlug=${encodeURIComponent(pageSlug)}`, request)
      .then(response => response)
      .catch(e => e);
  }
}

export default PinnedBlogs;
